import {Component, OnInit, OnDestroy} from '@angular/core';
import {RegistriesService} from '../../service';
import {ActivatedRoute, Router} from "@angular/router";
import {AlertService} from "@amlCore/components";
import {RiskfactorInfo} from "../../model";
import {AccessJson} from "@amlCore/models";
import {RegistriesAccessEnum} from "@amlCore/enums";
import {RiskFactorInfoFilter} from "@amlCore/models";
import {DictionaryService, UserService, VisitedService} from "@amlCore/services";
import {TableService} from "@amlCore/services";
import {IDataResponse, IDictionaryItem, IDictItemType} from "@amlCore/interfaces";
import {TableReactiveUrlController} from "@amlCore/tableReactive";
import {RiskAccessEnum} from "../../../core/enum/riskAccessEnum";

@Component({
  selector: 'app-registry-riskfactor-info',
  templateUrl: './riskfactorInfo.component.html'
})
export class RiskfactorInfoComponent extends TableReactiveUrlController implements OnInit, OnDestroy {

  isShowVisited = true;

  constructor(private readonly regSrv: RegistriesService,
              private readonly userSrv: UserService,
              private readonly alertSrv: AlertService,
              protected readonly activatedRoute: ActivatedRoute,
              protected readonly visitedService: VisitedService,
              protected readonly tableService: TableService,
              protected readonly dictSrv: DictionaryService,
              protected readonly router: Router) {
    super(router, activatedRoute, visitedService, tableService, {pageSize: 20, sort: 'type', dir: 'ASC'});
  }

  public riskfactorInfoEntries: RiskfactorInfo[] = [];

  private npa: IDictionaryItem<{ id: string; name: string; }>[] = [];
  private riskLevels: IDictItemType[] = [];
  access: AccessJson;

  ngOnInit() {
    this.access = this.userSrv.getAccess(RiskAccessEnum.RISK_LIST);
    this.activatedRoute.queryParams.subscribe((data: RiskFactorInfoFilter) => {
      this.loadList(this.syncParams(data));
    });
    this.dictSrv.getRemoteData('risklevel').then((result) => {
      this.riskLevels = result;
    });
    this.dictSrv.getRemoteData('npa').then((result) => {
      this.npa = result.map((item: any) => {return {id: item.code, name: item.name};});
    });
  }

  /**
   * метод получения объекта плоского фильтра
   * @param data объект фильтра с полями
   */
  public getFilterObject(data): RiskFactorInfoFilter {
    const filter = this.tableService.getFilterSubject(data);
    return this.getFilterPlanObject(filter) as RiskFactorInfoFilter;
  }

  onPageChange(params: RiskFactorInfoFilter) {
    this.navigate({...params, ...this.getParams(params)});
  }

  loadList(params?: RiskFactorInfoFilter) {
    this.regSrv.getRiskfactorEntries(this.getParams(params)).subscribe((data: IDataResponse<RiskfactorInfo>) => {
      this.riskfactorInfoEntries = data.content;
      this.total = data.totalElements;
      this.scrollRun();
    });
  }

  onSearch() {
    const params = this.getSearchPage(this.filter) as RiskFactorInfoFilter;
    this.onPageChange(params);
  }

  public edit(rInfo: RiskfactorInfo) {
    this.tableService.saveScrollPosition(this.commonKeyStore);
    this.router.navigate(['registries/riskfactorCountry', rInfo.id, {whereOpenUrl: this.router.url}]);
  }

  public remove(rInfo: RiskfactorInfo) {
    this.alertSrv.clear();
    this.regSrv.deleteRiskfactor(rInfo.id).subscribe(data => {
      this.alertSrv.success(`Запись ${rInfo.npa} удалена!`);
      this.loadList();
    });
  }

  public addNewItem() {
    this.router.navigate(['registries/riskfactorCountryNew', {whereOpenUrl: this.router.url}]);
  }

  public getNpa(id: string) {
    return this.dictSrv.getNpa(id, this.npa);
  }

  getRiskLevelName(code: string): string {
    return this.dictSrv.getDictNameByCode(code, this.riskLevels);
  }

  ngOnDestroy() {
    this.checkScrollOptions();
  }
}
